import { database, auth, initializeApp } from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

const production = {
  apiKey: 'AIzaSyCzw-JPgfG5QA_pJfKnU2vASrIYux33ZCE',
  authDomain: 'markerboard.hashrocket.com',
  databaseURL: 'https://markerboard-e5e1a.firebaseio.com',
};

const development = {
  apiKey: 'AIzaSyBDn3svfJ4a32v_zwhl7940uarfL9TVC0w',
  authDomain: 'markerboard-dev-7edc8.firebaseapp.com',
  databaseURL: 'https://markerboard-dev-7edc8.firebaseio.com',
};

const app = {
  production,
  development,
};

export const initFirebase = () => {
  initializeApp(app[process.env.NODE_ENV]);
};

export const signIn = () => {
  let provider = new auth.GoogleAuthProvider();
  provider.setCustomParameters({
    prompt: 'select_account',
    hd: 'hashrocket.com',
  });
  return auth()
    .signInWithPopup(provider)
    .then(isAuthorized);
};

export const isAuthorized = result => {
  if (
    result.credential &&
    result.user.emailVerified === true &&
    /.*@hashrocket.com$/.test(result.user.email)
  ) {
    return result;
  } else {
    return false;
  }
};

export const checkForSignIn = async ({
  ifAuthorized: ifAuthorizedCallback,
}) => {
  await initFirebase();

  return auth().onAuthStateChanged(async user => {
    if (user) {
      if (isAuthorized({ credential: true, user })) {
        return ifAuthorizedCallback({ user });
      } else {
        await auth().signOut();
      }
    } else {
      const user = await signIn();
      if (user) {
        return ifAuthorizedCallback(user);
      }
    }

    alert('You are not authorized. This incident will be reported.');
    window.location.reload();
  });
};

export const markerboardRef = path =>
  database()
    .ref(path)
    .child('markerboard');



// WEBPACK FOOTER //
// ./src/firebase.js